import CompraDeudaImportPage from "./CompraDeudaImportPage";

export {CompraDeudaImportPage}
export default CompraDeudaImportPage
